import { createConfigurable } from '@core/config-singleton/createConfigurable';

export const { config, updateConfig } = createConfigurable({
  libraryPageSize: 18,
});
